// 슈퍼어드민(스토어 관리 / 스토어 모니터·분석) 접근 권한 — 단일 출처(single source of truth).
// 사이드바 메뉴 노출(Sidebar.js)과 라우트 직접 접근 가드(App.js)가 동일 기준을 공유한다.

export const SUPER_ADMIN_EMAIL = 'admin@onnomads.com';
export const SUPER_ADMIN_STORE_ID = '65dc0c0a6b72d264c3419af0';

// 슈퍼어드민 전용 라우트 그룹: 스토어 관리(aoa), 스토어 모니터/분석(aoaMonitor)
export const SUPER_ADMIN_MENUS = ['aoa', 'aoaMonitor'];

// me = teamUser.me. 지정 계정 + 지정 스토어일 때만 슈퍼어드민.
export function isSuperAdmin(me) {
  return !!me
    && me.email === SUPER_ADMIN_EMAIL
    && me.selStore_id === SUPER_ADMIN_STORE_ID;
}

// 해당 라우트가 슈퍼어드민 전용인지 (route.info.mainMenu 기준)
export function isSuperAdminOnlyRoute(route) {
  return !!(route && route.info && SUPER_ADMIN_MENUS.indexOf(route.info.mainMenu) !== -1);
}
